import React from 'react'

const CardHeadeWithActions = ({children,title}) => {
    return (
        <div id='Header' className='flex  items-center border-b border-gray-200 p-3 pb-3   '>
            <div  className='flex-1 font-bold text-[#261759]'>{title}</div>
            {children}
        </div>
    )
}

export default CardHeadeWithActions
